import 'regenerator-runtime/runtime'
import { createStore, applyMiddleware } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import createSagaMiddleware from 'redux-saga'
import rootReducer from 'redux/reducers/rootReducer'
import { rootSaga } from 'redux/sagas/rootSaga'

const sagaMiddleware = createSagaMiddleware()

export function configureStore() {
    const resultStore = createStore(
        rootReducer,
        composeWithDevTools(applyMiddleware(sagaMiddleware))
    )

    sagaMiddleware.run(rootSaga)

    return resultStore
}

export const store = configureStore()

export type AppDispatch = typeof store.dispatch
